require('angular')
require('angular-route')
require('../../../core/translation/translation-module')
require('../form/form-module')
require('../number/number-module')
require('../remote-api/remote-api-module')
require('../truncate/truncate_module.coffee')

ScoreCardUIService = require('./score-card-ui-service')
ScoreCardParser = require('./score-card-parser')
ScoreCardDirective = require('./score-card-directive')
ScoreCardDetailDirective = require('./score-card-detail-directive')
ScoreCardUtilityService = require('./score-card-utility-service')
teeOfClubLabelFilter= require('./tee-of-club-filter')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-form'
  'gnp-number'
  'gnp-remote-api'
  'gnp-truncate'
]

angular.module 'gnp-score-card', modules
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .factory "ScoreCardParser", ScoreCardParser
  .factory "ScoreCardUIService", ScoreCardUIService
  .factory "ScoreCardUtilityService", ScoreCardUtilityService
  .directive('gnpScoreCard', ScoreCardDirective)
  .directive('gnpScoreCardDetail', ScoreCardDetailDirective)
  .filter 'teeOfClubLabel', teeOfClubLabelFilter



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/score-card-module.coffee